import { observable, action, runInAction } from 'mobx';
import streamManagementAPI from '../apis/streamManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class StreamManagementStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;

  /*SearchResult start*/
  @observable searchItem = {
    "dagNames": []
  }
  @observable dataList = []
  @observable stateList = []
  @action
  async onSearchStreamAction(params) {
    this.isFetching = true;
    this.dataList = [];
    this.stateList = [];
    try {
      const response = await streamManagementAPI.searchAction(params);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          const newList = []
          const filterList = []
          for (let j = 0; j< response.data.data.data.length; j++) {
            if(newList.indexOf(response.data.data.data[j].state)===-1){
              newList.push(response.data.data.data[j].state)
            }
          }
          newList.filter(it=>it !== null).map(item=>{ return filterList.push({ text: item, value: item, })})
          this.dataList = response.data.data?.data || []
          this.stateList = filterList;
          this.searchItem = params;
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/

  /*edit permission*/
  @action
  async onRestartStreamAction(params){
    this.isFetching = true
    try {
      const response = await streamManagementAPI.restartAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          alertMessage.success('Restart Success！')
          this.onSearchStreamAction(this.searchItem)
        }else {
          alertMessage.error('Restart Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchStreamAction(this.searchItem)
  }
}
